export const designSkeletonStyles = {
  wrapper: {
    mb: {
      mobile: "6rem",
    },
  },
  skeleton: {
    height: {
      mobile: "20rem",
      tablet: "15.75rem",
    },
    mx: {
      tablet: "2.5rem",
      laptop: "auto",
    },
    width: {
      laptop: "88vw",
      desktop: "69.4375rem",
    },
    maxWidth: "69.4375rem",
  },
};
